@if (isEnrolling()) {
  <p>Follow the instructions to install the enrollment profile.</p>
} @else {
  <era-pairing-challenge-ui [challenge]="pairingChallenge()"
                            (enroll)="enroll($event)"></era-pairing-challenge-ui>
} @if (isVerifyingCode()) {
  <p>
    Verifying code
    <ml-sk-spinner-3 class="compact"></ml-sk-spinner-3>
  </p>
} @else if (isCodeInvalid()) {
  <p class="text-danger">
    The code has expired;<br />
    or is invalid.
  </p>
} @else if (isEnrollCompleted()) {
  <p class="text-success">The device has been successfully enrolled.</p>
} @else if (error()) {
  <p class="text-danger">
    An error occured. @if (environment.local) {
      <span>Please check if the certificate is trusted.</span>
    }
  </p>
} @if (environment.local) {
  <p>
    <a [attr.href]="ca"
       class="text-white">Download the Rocksoft CA certificate</a>
  </p>
}